// Mailbox history uses an explicit public vocabulary, not arbitrary stored
// messages or technical codes. Keep this formatter usable by paged history too.
export const emailRunFailureLabel = (run: {
  state: string;
  error?: { code?: string | null } | null;
}): string | null => {
  if (!run.error && run.state !== 'FAILED') return null;
  switch (run.error?.code) {
    case 'SOURCE_UNAUTHORIZED':
      return 'Access or eligibility changed before this run could start';
    case 'INACTIVE':
      return 'The trigger was not active when this run tried to start';
    case 'DEADLINE_EXPIRED':
      return 'This older run reached its launch time limit';
    default:
      return 'Email automation did not launch';
  }
};
